import { Component } from "@angular/core";
import { ExtractoPasajerosService } from "../../../../shared/services/extracto-pasajeros.service";
import { Router } from "@angular/router";
import { Utils } from "../../../../shared/utils/Utils";
import {
  Planilla,
  PlanillaService,
} from "../../../../shared/services/planillas.service";
import jsPDF from "jspdf";
import * as QRCode from 'qrcode';
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { Administracion } from "../../../../shared/model/administracion.model";
import { environment } from "../../../../../environments/environment";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ListadoPasajerosComponent } from "../../listado-pasajeros/listado-pasajeros.component";
import { ExtractoPasajero } from "../../../../shared/model/ExtractoPasajero.model";
import { autoTable } from "jspdf-autotable";
const Swal = require("sweetalert2");

@Component({
  selector: "app-listado-extractos",
  templateUrl: "./listado-extractos.component.html",
  styleUrls: ["./listado-extractos.component.scss"],
})
export class ListadoExtractosComponent {
  public selected = [];
  public searchText: string = ""; // Texto de búsqueda
  selectedEstado: any;
  filteredTableItems!: Planilla[];
  pageSize1: number = 5;
  page1: number = 1;
  totalItems!: number;
  planillas: any[] = [];
  administraciones: Administracion[] = [];
   altura: number = 0;
  ancho: number = 0;
  posicionX: number = 0;
  posicionY: number = 0;
  mostrandoToast = false;
  pasajeros: ExtractoPasajero[] = [];
  constructor(
    private planillaService: PlanillaService,
    private router: Router,
    private gpcGoogle: gpcGoogleService,
    private administracionesServices: AdministracionService,
    private modalService: NgbModal,
    private pasajerosService: ExtractoPasajerosService,
  ) {}

  ngOnInit() {
    this.selectedEstado = "";
    this.listarPlanilla();
    this.cargarDataAdmin();
  }

  listarPlanilla(): void {
    this.planillaService.getAllPlanillas().subscribe({
      next: (data) => {
      //  console.log(data);
        this.planillas= data;
        this.filteredTableItems = this.planillas; // ✅ Inicializa la tabla filtrada
      },
      error: (err) => {
        console.error("Error al cargar extractos", err);
      },
    });
  }

  avisoInactivarPlanilla(idfuec: string) {
    Swal.fire({
      title: "INACTIVAR EXTRACTO",
      text: `¿Desea inactivar el extracto?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.planillaService.inactivarPlanilla(idfuec).subscribe({
          next: (response) => {
            Swal.fire({
              icon: "success",
              title: "¡Éxito!",
              text: response.message || "Extracto inactivado correctamente",
              confirmButtonText: "Aceptar",
            });
            this.listarPlanilla(); // Recarga la lista solo si fue exitoso
          },
          error: (error) => {
            console.error("Error:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.error?.message || "No se pudo inactivar el extracto",
              confirmButtonText: "Aceptar",
            });
          },
        });
      }
    });
  }

filterData() {
  const search = this.searchText.toLowerCase();

  this.filteredTableItems = this.planillas.filter((item) =>
    String(item.idfuec)?.includes(search) ||
    item.interno?.toLowerCase().includes(search) ||
    item.placa?.toLowerCase().includes(search) ||
    item.responsable?.toLowerCase().includes(search) ||
    item.origen?.toLowerCase().includes(search) ||
    item.destino?.toLowerCase().includes(search)
  );

  this.page1 = 1;
}

  editarPersona(placa: string) {
    this.router.navigate(["/vehiculo/editar-vehiculo", placa]);
  }

  CrearVehiculo() {
    this.router.navigate(["/elaborar/elaborar"]);
  }
  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  estadoMap: { [key: string]: string } = {
    1: "badge badge-success", // Verde
    0: "badge badge-secondary", // Rojo
  };

  getEstadoColor(estado: string | undefined): string {
    return this.estadoMap[estado || ""] || "badge badge-light-danger";
  }

  formatearContrato(numero: number): string {
  return numero.toString().padStart(4, '0');
}

//imprimir fuec

 async addHeaderImages(
    doc: jsPDF,
    gpcGoogle: any,
    imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number }>,
    fallbackPath: string
  ) {
    // Obtener URL firmada de forma segura
    const getSignedUrlSafe = async (path: string) => {
      try {
        const res = await gpcGoogle.getSignedUrl(path).toPromise();
        return res?.url || null;
      } catch {
        return null;
      }
    };

    // Obtener imagen en base64, con fallback
    const getBase64WithFallback = async (url: string | null, fallbackPath: string) => {
      if (url) {
        try {
          return await gpcGoogle.getImageBase64(url);
        } catch {
          // fallback
        }
      }
      return await gpcGoogle.getImageBase64(fallbackPath);
    };

    // Comprimir base64 usando canvas
    const compressBase64Image = async (base64: string, quality = 0.1): Promise<string> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          if (!ctx) return reject("No canvas context");
          ctx.drawImage(img, 0, 0);
          const compressed = canvas.toDataURL("image/png", quality); // quality 0–1
          resolve(compressed);
        };
        img.onerror = reject;
        img.src = base64;
      });
    };

    // 1. Obtener las claves y rutas
    const imageEntries = Object.entries(imageMap);

    // 2. Obtener URLs firmadas
    const signedUrls = await Promise.all(
      imageEntries.map(([_, img]) => getSignedUrlSafe(img.path))
    );

    // 3. Obtener y comprimir Base64
    const base64Images = await Promise.all(
      signedUrls.map(async (url, index) => {
        const base64 = await getBase64WithFallback(url, fallbackPath);
        return base64 ? await compressBase64Image(base64, 0.6) : null; // puedes ajustar el 0.6
      })
    );

    // 4. Agregar imágenes al PDF
    base64Images.forEach((base64, idx) => {
      if (base64) {
        const { x, y, w, h } = imageEntries[idx][1];
        doc.addImage(base64, "JPEG", x, y, w, h, undefined, "FAST");
      }
    });
  }

async imprimirFuec(idFuec:any){
   this.mostrandoToast = true;
  this.planillaService.getPlanillaById(idFuec).subscribe({
  next: (response) => {   
   // console.log("FUEC:", response); 
   
   if(response.codigo==0){
    this.generarFuec(response.Planilla);
    
   }
    
  },
  error: (error) => {
    
  }
  
});
}



async generarFuec(planilla: any) {
  const doc = new jsPDF();
  //console.log("🧾 Generando FUEC con:", planilla);
   await this.addHeaderImages(doc, this.gpcGoogle, {
      supertransporte: { path: "ministerio/supertransporte.png", x: 105, y: 20, w: 50, h: 16 },
      minsupertransporte: { path: "ministerio/mintransporte.png", x: 55, y: 20, w: 50, h: 16 },
      potencia: { path: "ministerio/potencia.png", x: 10, y: 21, w: 40, h: 16 },
       logo: { path: `${this.administraciones[0].nit}/logos/logo.png`, x: this.posicionX, y: this.posicionY, w: this.ancho, h: this.altura },
   
    }, "../../../../../assets/images/hoja_vida/sinfoto.png");
  // Puedes acceder a todo el contenido
 
  const clase = planilla.clase;
   // === MARCA DE AGUA (de fondo) ===
const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();
// Opcional: Guardar estilos actuales
doc.saveGraphicsState();
doc.setFont('helvetica', 'normal');
doc.setFontSize(100);
doc.setTextColor(232, 232, 232); // Gris claro
doc.text('ORIGINAL', pageWidth / 2, pageHeight / 2, {
  align: 'center',
  angle: 0
});

doc.restoreGraphicsState();
  // Encabezado
  doc.setFontSize(12);
  doc.text('FICHA TÉCNICA DEL FORMATO ÚNICO DEL EXTRACTO DEL CONTRATO - FUEC', 105, 15, { align: 'center' });


  
  // Datos del contrato 


  doc.setFontSize(11);
  let y = 45;
  
  doc.setFont("helvetica","bold");
  doc.text('FORMATO ÚNICO DE EXTRACTO DEL CONTRATO DEL SERVICIO PÚBLICO DE', 105, y,{ align: 'center' });
   y += 5;
  doc.text('TRANSPORTE TERRESTRE AUTOMOTOR ESPECIAL', 105, y,{ align: 'center' });
  y += 5;
  const contratoFormateado1 = String(planilla.contrato).padStart(4, '0')
  const idfuecFormateado = String(planilla.idfuec).padStart(4, '0')
  doc.text('No '+ planilla.nfuec +contratoFormateado1+idfuecFormateado, 105, y,{ align: 'center' });
  


  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');

    y += 10;
  // Datos de la empresa
  doc.text('RAZÓN SOCIAL DE LA EMPRESA DE TRANSPORTE ESPECIAL:', 10, y);
  doc.text(planilla.infoEmpresa.empresa, 98, y);
   y += 5;
  doc.text('NIT:', 10, y);
  doc.text(planilla.nite, 60, y);


  // Datos del contrato
   y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('CONTRATO No.:', 10, y);
  doc.setFont('helvetica', 'normal');
  const contratoFormateado = planilla.contrato.toString().padStart(4, '0');
  doc.text(contratoFormateado, 60, y);
  

  y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('CONTRATANTE:', 10, y);
  doc.setFont('helvetica', 'normal');
  
  doc.text(planilla.nitc, 60, y);

  y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('NIT/CC:', 10, y);
  doc.setFont('helvetica', 'normal');
  doc.text(planilla.empresa, 60, y);

  // Objeto
   y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('OBJETO DEL CONTRATO:', 10,y);
  doc.setFont('helvetica', 'normal');
  doc.text(planilla.descripcionObjeto.descripcion, 60,y);
  
    if (planilla.complemento) {
    y += 3;
    doc.setFontSize(7); // Reducir tamaño de fuente para disponibilidad
    const maxWidth = 140; // Ancho máximo para el texto
    const textLines = doc.splitTextToSize(planilla.complemento, maxWidth);
    doc.text(textLines, 60, y);
    // Ajustar Y según la cantidad de líneas del complemento
    y += (textLines.length - 1) * 4;
   }
  // ORIGEN DESTION VIAJE
   y += 5;
    doc.setFontSize(8); // Reducir tamaño de fuente para disponibilidad
  doc.setFont('helvetica', 'bold');
  doc.text('ORIGEN - DESTINO:', 10,y);
  doc.setFont('helvetica', 'normal');
  
  if (planilla.disponibilidad) {
    doc.setFontSize(7); // Reducir tamaño de fuente para disponibilidad
    const maxWidth = 140; // Ancho máximo para el texto
    const textLines = doc.splitTextToSize('DISPONIBILIDAD TOTAL:' + planilla.disponibilidad + " " + planilla.descripcionViaje.descripcion, maxWidth);
    doc.text(textLines, 60, y);
    // Ajustar Y según la cantidad de líneas (cada línea ocupa ~4 unidades con fuente más pequeña)
    y += (textLines.length - 1) * 4;
    doc.setFontSize(8); // Restaurar tamaño de fuente
  } else {
    doc.setFontSize(8);
    const maxWidth = 150; // Ancho máximo para el texto
    const textLines = doc.splitTextToSize(planilla.origen + ' - ' + planilla.destino + " " + planilla.descripcionViaje.descripcion, maxWidth);
    doc.text(textLines, 60, y);
    // Ajustar Y según la cantidad de líneas
    y += (textLines.length - 1) * 4;
    doc.setFontSize(8);
  }

  // ORIGEN DESTION VIAJE
   y += 5;
   if(planilla.conv && planilla.conv!=""){
    doc.setFont('helvetica', 'bold');
    doc.text('CONVENIO DE COLABORACIÓN:', 10,y);
    doc.setFont('helvetica', 'normal');
    doc.text( planilla.vehiculo.nombreEmpresa.nombre, 60,y);
   }else{
     doc.setFont('helvetica', 'bold');
    doc.text('CONVENIO DE COLABORACIÓN:', 10,y);
    doc.setFont('helvetica', 'normal');
    doc.text( "-", 60,y);
   }
  
  
     y += 10;
   doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('VIGENCIA DEL CONTRATO', 105, y,{ align: 'center' });

  // Estilos de fondo y bordes
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(12);
 y += 2;
// Coordenadas y anchos de columnas
const x1 = 10;
const w1 = 92;

const x2 = x1 + w1;   // 105
const w2 = 30;
const w3 = 30;
const w4 = 30;

// Dibujar celdas
doc.rect(x1, y, w1, 10, 'S');             // FECHA INICIAL
doc.rect(x2, y, w2, 10, 'S');             // DÍA
doc.rect(x2 + w2, y, w3, 10, 'S');        // MES
doc.rect(x2 + w2 + w3, y, w4, 10, 'S');   // AÑO



const fecha = new Date(planilla.finicial);
const dia = String(fecha.getUTCDate()).padStart(2, '0');
const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
const anio = String(fecha.getUTCFullYear());


// Escribir texto centrado
doc.setFont('helvetica', 'normal');
doc.text("FECHA INICIAL", x1 + 2, y + 7); // alineado a la izquierda (2px de margen)
doc.setFont('helvetica', 'bold');
doc.text("DÍA", x2 + w2 / 2, y + 4.5, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.text(dia, x2 + w2 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("MES", x2 + w2 + w3 / 2, y + 4.5, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.text(mes, x2 + w2 + w3 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("AÑO", x2 + w2 + w3 + w4 / 2, y + 4.5, { align: 'center' })
doc.setFont('helvetica', 'normal');
doc.text(anio, x2 + w2 + w3 + w4 / 2, y + 9, { align: 'center' });

  y += 2;
     

   // Estilos de fondo y bordes
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(12);
 y += 8;



// Dibujar celdas
doc.rect(x1, y, w1, 10, 'S');             // FECHA INICIAL
doc.rect(x2, y, w2, 10, 'S');             // DÍA
doc.rect(x2 + w2, y, w3, 10, 'S');        // MES
doc.rect(x2 + w2 + w3, y, w4, 10, 'S');   // AÑO

const fecha2 = new Date(planilla.ffinal);
const dia2 = String(fecha2.getUTCDate()).padStart(2, '0');
const mes2 = String(fecha2.getUTCMonth() + 1).padStart(2, '0');
const anio2 = String(fecha2.getUTCFullYear());

// Escribir texto centrado
doc.text("FECHA VENCIMIENTO", x1 + 2, y + 7); // alineado a la izquierda (2px de margen)
doc.text("DÍA", x2 + w2 / 2, y + 4.5, { align: 'center' });
doc.text(dia2, x2 + w2 / 2, y + 9, { align: 'center' });

doc.text("MES", x2 + w2 + w3 / 2, y + 4.5, { align: 'center' });
doc.text(mes2, x2 + w2 + w3 / 2, y + 9, { align: 'center' });
doc.text("AÑO", x2 + w2 + w3 + w4 / 2, y + 4.5, { align: 'center' })
doc.text(anio2, x2 + w2 + w3 + w4 / 2, y + 9, { align: 'center' });

 
  y += 20;
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('CARACTERÍSTICA DEL VEHÍCULO', 105, y,{ align: 'center' });
  y += 2;

 
     

   // Estilos de fondo y bordes
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(12);



const x11 = 10;

// Anchos de columnas
const w11 = 45; // PLACA
const w22 = 46; // MODELO
const w33 = 45; // MARCA
const w44 = 46; // CLASE

// Dibujar celdas
doc.rect(x11, y, w11, 10, 'S');                   // PLACA
doc.rect(x11 + w11, y, w22, 10, 'S');              // MODELO
doc.rect(x11 + w11 + w22, y, w33, 10, 'S');         // MARCA
doc.rect(x11 + w11 + w22 + w33, y, w44, 10, 'S');    // CLASE

// Escribir texto centrado en cada celda (horizontal y vertical)
const yText = y + 6; // Centrado verticalmente (ajustable)

doc.text("PLACA", x11 + w11 / 2, yText, { align: 'center' });
doc.text("MODELO", x11 + w11 + w22 / 2, yText, { align: 'center' });
doc.text("MARCA", x11 + w11 + w22 + w33 / 2, yText, { align: 'center' });
doc.text("CLASE", x11 + w11 + w22 + w33 + w44 / 2, yText, { align: 'center' });
 y += 10;
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);

// Dibujar celdas
doc.rect(x11, y, w11, 10, 'S');                   // PLACA
doc.rect(x11 + w11, y, w22, 10, 'S');              // MODELO
doc.rect(x11 + w11 + w22, y, w33, 10, 'S');         // MARCA
doc.rect(x11 + w11 + w22 + w33, y, w44, 10, 'S');    // CLASE
 doc.setFont('helvetica', 'normal');
 doc.text(planilla.placa, x11 + w11 / 2, y + 6, { align: 'center' }); //PLACA

const modeloStr = planilla.modelo ? String(planilla.modelo) : '';
doc.text(modeloStr, x11 + w11 + w22 / 2, y + 6, { align: 'center' }); //MODELO

doc.text(planilla.marca, x11 + w11 + w22 + w33 / 2, y + 6, { align: 'center' }); //MARCA
doc.text(clase, x11 + w11 + w22 + w33 + w44 / 2, y + 6, { align: 'center' }); //CLASE

//interno
 y += 10; // Moverse a la siguiente fila

const x111 = 10;
const w111 = 45;
const h = 10;

doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);

doc.setFont('helvetica', 'bold');
// Celda 1: INTERNO
doc.rect(x111, y, w111 + 46, h, 'S');
doc.text("NÚMERO INTERNO", x111 + (w111 + 46) / 2, y + 6, { align: 'center' });

doc.setFillColor(255, 255, 255); // fondo blanco
doc.setTextColor(0, 0, 0);       // texto negro
doc.setDrawColor(0);            // bordes negros

// Celda 1: INTERNO
doc.rect(x111+91, y, w111 + 46, h, 'S');
doc.text("TARJETA DE OPERACIÓN", x111 +91+ (w111 + 46) / 2, y + 6, { align: 'center' });


doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);
// ↓↓↓ NUEVA FILA DE VALORES DEBAJO ↓↓↓
y += h;

// Valor debajo de NÚMERO INTERNO
doc.rect(x111, y, w111 + 46, h, 'S');
doc.setFont('helvetica', 'normal');
const internoStr = planilla.interno ? String(planilla.interno) : '';
doc.text(internoStr, x111 + (w111 + 46) / 2, y + 6, { align: 'center' });


doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);
doc.setFont('helvetica', 'normal');
// Valor debajo de TARJETA DE OPERACIÓN
doc.rect(x111 + 91, y, w111 + 46, h, 'S');
const tarjetaStr = planilla.operaciones ? String(planilla.operaciones) : '';
doc.text(tarjetaStr, x111 + 91 + (w111 + 46) / 2, y + 6, { align: 'center' });


 y += 10; // Moverse a la siguiente fila

const h2 = 14;
const x112 = 10;
const w112 = 32;

doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
// Agregar texto dividido en dos líneas
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("CONDUCTOR No. 1", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');

if (!planilla.conductor || planilla.conductor.trim() === '') {
  planilla.conductor = "-";
}

if (!planilla.cedula || planilla.cedula.trim() === '') {
  planilla.cedula = "-";
}

if (!planilla.licencia || planilla.licencia.trim() === '') {
  planilla.licencia = "-";
}

doc.text(planilla.conductor, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.cedula, x112 + 105, y + 9, { align: 'center' });

const xText = x112 + 105 + 28; // posición X centrada para la columna
const yStart = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("NÚMERO LICENCIA", xText, yStart, { align: 'center' });
doc.text("CONDUCCIÓN", xText, yStart + 4, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.licencia, xText, yStart + 8, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("VIGENCIA", xText+30, yStart, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);

if(planilla.vigencia){
const fechaOriginal = planilla.vigencia;
const fecha1 = new Date(fechaOriginal);

const diaVig = String(fecha1.getUTCDate()).padStart(2, '0');
const mesVig = String(fecha1.getUTCMonth() + 1).padStart(2, '0');
const anioVig = fecha1.getUTCFullYear();
const fechaFormateada = `${diaVig}/${mesVig}/${anioVig}`;
doc.text(fechaFormateada, xText+30, yStart + 8, { align: 'center' });
}else{
  doc.text("-", xText+30, yStart + 8, { align: 'center' });
}

y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("CONDUCTOR No. 2", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');

if (!planilla.conductor1 || planilla.conductor1.trim() === '') {
  planilla.conductor1 = "-";
}

if (!planilla.cedula1 || planilla.cedula1.trim() === '') {
  planilla.cedula1 = "-";
}

if (!planilla.licencia1 || planilla.licencia1.trim() === '') {
  planilla.licencia1 = "-";
}



doc.text(planilla.conductor1, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');

doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.cedula1, x112 + 105, y + 9, { align: 'center' });

const xText1 = x112 + 105 + 28; // posición X centrada para la columna
const yStart1 = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("NÚMERO LICENCIA", xText1, yStart1, { align: 'center' });
doc.text("CONDUCCIÓN", xText1, yStart1 + 4, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.setFontSize(8);
doc.text(planilla.licencia1, xText1, yStart1 + 8, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("VIGENCIA", xText1+30, yStart1, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);

if(planilla.vigencia1){
const fechaOriginal22 = planilla.vigencia1;
const fecha221 = new Date(fechaOriginal22);

const diaVig1 = String(fecha221.getUTCDate()).padStart(2, '0');
const mesVig1 = String(fecha221.getUTCMonth() + 1).padStart(2, '0');
const anioVig1 = fecha221.getUTCFullYear();
const fechaFormateada22 = `${diaVig1}/${mesVig1}/${anioVig1}`;
doc.text(fechaFormateada22, xText1+30, yStart1 + 8, { align: 'center' });
}else{
  doc.text("-", xText1+30, yStart1 + 8, { align: 'center' });
}

y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("CONDUCTOR No. 3", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
if (!planilla.conductor2 || planilla.conductor2.trim() === '') {
  planilla.conductor2 = "-";
}

if (!planilla.cedula2 || planilla.cedula2.trim() === '') {
  planilla.cedula2 = "-";
}

if (!planilla.licencia2 || planilla.licencia2.trim() === '') {
  planilla.licencia2 = "-";
}



doc.text(planilla.conductor2, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(8);
doc.setFontSize(10);
doc.text(planilla.cedula2, x112 + 105, y + 9, { align: 'center' });

const xText11 = x112 + 105 + 28; // posición X centrada para la columna
const yStart11 = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("NÚMERO LICENCIA", xText11, yStart11, { align: 'center' });
doc.text("CONDUCCIÓN", xText11, yStart11 + 4, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.licencia2, xText11, yStart11 + 8, { align: 'center' });

if(planilla.vigencia2){
const fechaOriginal2 = planilla.vigencia2;
const fecha22 = new Date(fechaOriginal2);

const diaVig2 = String(fecha22.getUTCDate()).padStart(2, '0');
const mesVig2 = String(fecha22.getUTCMonth() + 1).padStart(2, '0');
const anioVig2 = fecha22.getUTCFullYear();
const fechaFormateada2 = `${diaVig2}/${mesVig2}/${anioVig2}`;

//console.log(fechaFormateada2); // "07/03/2026"
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("VIGENCIA", xText11+30, yStart11, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(fechaFormateada2, xText11+30, yStart11 + 8, { align: 'center' });
}else{
  doc.text("-", xText11+30, yStart11 + 8, { align: 'center' });
}



y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("RESPONSABLE", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.text(planilla.responsable, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.text(planilla.idresponsable, x112 + 105, y + 9, { align: 'center' });

const xText111 = x112 + 105 + 28; // posición X centrada para la columna
const yStart111 = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("TELÉFONO", xText111, yStart111, { align: 'center' });


doc.setFont('helvetica', 'normal');
doc.setFontSize(8);
const telefonorStr = planilla.telefonor ? String(planilla.telefonor) : '';
doc.text(telefonorStr, xText111, yStart111 + 5, { align: 'center' });

const textDireccion = planilla.direccionr || '';
const maxWidth = 40; // ajusta al ancho máximo que quieras
const textLines = doc.splitTextToSize(textDireccion, maxWidth);

doc.setFont('helvetica', 'bold');
doc.text("DIRECCIÓN", xText111 + 30, yStart111, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.text(textLines, xText111 + 30, yStart111 + 3, { align: 'center' });

y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112+59, h2+20, 'S');
doc.rect(x112+91, y, w112+59, h2+20, 'S');
doc.setFont('helvetica', 'normal');
y += 5;
doc.setFontSize(10);
doc.text(planilla.infoEmpresa.direccion, 12,y);

y += 5; // Moverse a la siguiente fila
const telefonoStr =planilla.infoEmpresa.telefono ? String(planilla.infoEmpresa.telefono) : '';
doc.text(telefonoStr, 12,y);
y += 5; // Moverse a la siguiente fila
doc.text(planilla.infoEmpresa.email, 12,y);
y += 5; // Moverse a la siguiente fila
doc.text(planilla.infoEmpresa.web, 12,y);

if (this.administraciones.length > 0) {
  const firmaPath = this.administraciones[0].nit + "/logos/firma.png";
  try {
    const firmaUrl = await this.gpcGoogle.getSignedUrl(firmaPath).toPromise();
    if (firmaUrl?.url) {
      // Intentar obtener la imagen, solo agregar si existe
      try {
        const firmaBase64 = await this.gpcGoogle.getImageBase64(firmaUrl.url);
        if (firmaBase64) {
          doc.addImage(firmaBase64, "PNG", 115, y-10, 60, 15);
        }
      } catch (e) {
        // No agregar imagen si no existe
      }
    }
  } catch (e) {
    // No agregar imagen si no existe
  }
}
  doc.setFontSize(10);
  doc.text("FIRMA GERENTE EMPRESA", 125, y + 10);
  
  // Registro de fecha y hora en posición fija vertical con formato dd/mm/aa
  doc.setFontSize(8);
  const fechaRegistro = new Date(planilla.registro);
  const diaReg = String(fechaRegistro.getUTCDate()).padStart(2, '0');
  const mesReg = String(fechaRegistro.getUTCMonth() + 1).padStart(2, '0');
  const anioReg = String(fechaRegistro.getUTCFullYear()).slice(-2);
  const textoRegistro = `${diaReg}/${mesReg}/${anioReg} ${planilla.hora}`;
  doc.text(textoRegistro, 195, 270, { angle: 90 });
  
  // Generar QR y posicionarlo de forma absolutamente fija
  const qrBase64 = await QRCode.toDataURL(environment.apiUrl + "/api/validar-fuec/"+ this.administraciones[0].consumidas+"/"+planilla.idfuec);
  
  // Posición fija en la parte inferior izquierda (sin depender de variables dinámicas)
  const qrX = 75;
  const qrY = 252; // Posición fija en el eje Y
  const qrSize = 20;
  
  doc.addImage(qrBase64, 'PNG', qrX, qrY, qrSize, qrSize);
   this.addFooter(doc, planilla.idfuec);

  //VALIDAR SI TENEMOS LISTADO DE PASAJEROS 
  try {
  
  await this.getListadoPasajeros(planilla.idfuec);

   if (this.pasajeros && this.pasajeros.length > 0) {
     // Lógica si hay pasajeros
     doc.addPage();
   //  doc.text("Listado de Pasajeros", 10, 10);
     this.generarListado(doc, this.pasajeros, planilla);
   }
  } catch (e) {
    console.error('Error obteniendo listado de pasajeros:', e);
  }

  // Abrir el PDF en nueva pestaña
  const blobUrl = doc.output('bloburl');
  window.open(blobUrl, '_blank');
}


//VALIDAR SI TENEMOS LISTADO DE PASAJEROS
async getListadoPasajeros(extractoId: number): Promise<void> {
  // Lógica para obtener el listado de pasajeros según el ID del extracto
  console.log('Obteniendo listado de pasajeros para extracto ID:', extractoId);

  await this.cargarPasajeros(extractoId);
}

 async cargarPasajeros(extractoId:  number): Promise<void> {
  
    if (!extractoId) {
      Swal.fire('Atención', 'No se recibió el ID del extracto.', 'warning');
      return;
    }

 

    return new Promise<void>((resolve, reject) => {
      this.pasajerosService.listarPasajeros(extractoId).subscribe({
        next: (respuesta: any) => {
          this.pasajeros =
            Array.isArray(respuesta)
              ? respuesta
              : respuesta?.data ?? respuesta?.pasajeros ?? [];
          console.log('Pasajeros cargados:', this.pasajeros);
          console.log('Respuesta completa:', respuesta);

          //this.cargando = false;
          resolve();
        },
        error: (error) => {
          console.error('Error cargando pasajeros:', error);
         // this.cargando = false;

          Swal.fire(
            'Error',
            'No fue posible cargar los pasajeros del extracto.',
            'error'
          );
          reject(error);
        }
      });
    });
  }

addFooter(doc: jsPDF,  id: string | number) {
  const pageWidth = doc.internal.pageSize.width;

  const now = new Date();
  const fecha = now.toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const hora = now.toLocaleTimeString("es-CO", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const fechaHora = `${fecha} ${hora}`;
  const idFormatted = String(id).padStart(4, '0'); // ejemplo: 0042

  doc.setFont("helvetica", "italic");
  doc.setFontSize(8);
  doc.setTextColor(100);

  // Posiciones fijas del footer
  const footerY1 = 291; // Posición fija para fecha/ID
  const footerY2 = 291; // Posición fija para texto central

  // 🕓 Izquierda: Fecha y hora
  doc.text(fechaHora, 10, footerY1);

  // 🏢 Centro: Texto con enlace
  doc.textWithLink(
    "Generado desde Admin SEAF – INDESOFT - ORIGINAL",
    pageWidth / 2,
    footerY2,
    {
      url: "https://indesoftsas.com",
      align: "center",
    }
  );

  // 📄 Derecha: ID + número de página
  doc.text(`ID: ${idFormatted} `, pageWidth - 10, footerY1, {
    align: "right",
  });
  this.mostrandoToast = false;

  // Fin de la función addFooter
}

   private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {

        this.administraciones = data;
        this.altura = data[0].dimensionLogo.h;      // "8"
        this.ancho = data[0].dimensionLogo.w;       // "40"
        this.posicionX = data[0].dimensionLogo.fx;   // 10
        this.posicionY = data[0].dimensionLogo.fy;  
      
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
 
 
  }


gestionarPasajeros(extracto: any): void {
  if (!extracto) {
    console.error('No se encontró el extracto');
    return;
  }

  const modalRef = this.modalService.open(
    ListadoPasajerosComponent,
    {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
      scrollable: true
    }
  );

  modalRef.componentInstance.extracto = extracto;
  modalRef.componentInstance.extractoId = extracto.idfuec;

  modalRef.componentInstance.pasajeros = [
    ...(this.pasajeros ?? [])
  ];

  console.log('Modal abierto. Esperando resultado...');

  modalRef.result.then(
    (resultado) => {
      // Este log se ejecuta aunque actualizado sea false
      //console.log('Resultado completo del modal:', resultado);
      ///console.log('Pasajeros recibidos:', resultado?.pasajeros);
      //console.log('Actualizado:', resultado?.actualizado);

      if (resultado?.actualizado) {
        this.pasajeros = resultado.pasajeros ?? [];

       /*    console.log(
            'Pasajeros almacenados en CrearExtractoComponent:',
            this.pasajeros
          ); */
      }
    },
    (error) => {
      console.error('El modal fue rechazado:', error);
    }
  );
}

generarListado(pdf: jsPDF, pasajeros: any[] = this.pasajeros,extracto: any ): void {
  console.log('Generando listado de pasajeros...');

  // Filtrar únicamente pasajeros activos
  const pasajerosActivos = (pasajeros || [])
    .filter(pasajero => pasajero.estado === 'ACTIVO');

  if (pasajerosActivos.length === 0) {
    Swal.fire(
      'Sin pasajeros activos',
      'No hay pasajeros activos para generar el listado.',
      'info'
    );
    return;
  }

  // Configuración del documento

  const anchoPagina = pdf.internal.pageSize.getWidth();
  const altoPagina = pdf.internal.pageSize.getHeight();
  const margen = 14;


  const fechaActual = new Date();
  const fecha = fechaActual.toLocaleDateString('es-CO');
  const hora = fechaActual.toLocaleTimeString('es-CO', {
    hour: '2-digit',
    minute: '2-digit'
  });

  // Evitar valores nulos o vacíos
  const dato = (valor: unknown): string => {
    if (
      valor === null ||
      valor === undefined ||
      String(valor).trim() === ''
    ) {
      return 'SIN DATOS';
    }

    return String(valor).trim();
  };

  const origen = extracto?.origen?.trim() || '';
  const destino = extracto?.destino?.trim() || '';

  const ruta = origen || destino
    ? `${origen || 'SIN DATOS'} - ${destino || 'SIN DATOS'}`
    : 'SIN DATOS';

  // ==========================================
  // 1. ENCABEZADO CORPORATIVO
  // ==========================================

  pdf.setFillColor(82,82,82);
  pdf.rect(0, 0, anchoPagina, 8, 'F');

  pdf.setTextColor(55, 65, 81);
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(17);

/*   pdf.text(
    'ADMIN SEAF',
    anchoPagina / 2,
    19,
    { align: 'center' }
  );
 */
  pdf.setFontSize(12);

  pdf.text(
    'LISTADO DE PASAJEROS',
    anchoPagina / 2,
    19,
    { align: 'center' }
  );

  // Línea decorativa roja
  pdf.setDrawColor(61, 61,61);
  pdf.setLineWidth(0.8);

  pdf.line(
    margen,
    24,
    anchoPagina - margen,
    24
  );

  // ==========================================
  // 2. INFORMACIÓN DEL EXTRACTO
  // ==========================================

  pdf.setFillColor(245, 246, 248);

  pdf.roundedRect(
    margen,
    30,
    anchoPagina - margen * 2,
    34,
    2,
    2,
    'F'
  );

  pdf.setTextColor(55, 65, 81);
  pdf.setFontSize(8.5);

  const xEtiquetaIzquierda = margen + 5;
  const xDatoIzquierda = margen + 30;

  const xEtiquetaDerecha = 112;
  const xDatoDerecha = 151;

  // Columna izquierda
  pdf.setFont('helvetica', 'bold');
  pdf.text('PLACA:', xEtiquetaIzquierda, 44);
  pdf.text('CONTRATANTE:', xEtiquetaIzquierda, 52);
  pdf.text('ID FUEC:', xEtiquetaIzquierda, 60);

  pdf.setFont('helvetica', 'normal');
  pdf.text(dato(extracto?.placa), xDatoIzquierda, 44);
  pdf.text(dato(extracto?.nitc), xDatoIzquierda, 52);
  pdf.text(dato(extracto?.idfuec), xDatoIzquierda, 60);

  // Columna derecha
  pdf.setFont('helvetica', 'bold');
  pdf.text('ORIGEN - DESTINO:', xEtiquetaDerecha, 44);
  pdf.text('IMPRESIÓN:', xEtiquetaDerecha, 52);
  pdf.text('TOTAL ACTIVOS:', xEtiquetaDerecha, 60);

  pdf.setFont('helvetica', 'normal');

  // Limitar textos largos para evitar que se superpongan
  const anchoDatoDerecha = anchoPagina - margen - xDatoDerecha;

  pdf.text(
    pdf.splitTextToSize(ruta, anchoDatoDerecha)[0],
    xDatoDerecha,
    44
  );

  pdf.text(
    `${fecha} ${hora}`,
    xDatoDerecha,
    52
  );

  pdf.setFont('helvetica', 'bold');
  pdf.text(
    String(pasajerosActivos.length),
    xDatoDerecha,
    60
  );

  // ==========================================
  // 3. TABLA DE PASAJEROS ACTIVOS
  // ==========================================

  autoTable(pdf, {
    startY: 70,

    head: [[
      '#',
      'TIPO DOCUMENTO',
      'NÚMERO DOCUMENTO',
      'NOMBRE COMPLETO',
      
     
    ]],

    body: pasajerosActivos.map((pasajero, index) => [
      index + 1,
      dato(pasajero.tipo_documento),
      String(pasajero.numero_documento ?? ''),
      dato(pasajero.nombresCompleto),
     // pasajero.observacion?.trim() || 'SIN OBSERVACIÓN',
     
    ]),

    theme: 'grid',

    styles: {
      font: 'helvetica',
      fontSize: 8,
      cellPadding: 3,
      overflow: 'linebreak',
      textColor: [55, 65, 81],
      lineColor: [220, 223, 228],
      lineWidth: 0.2,
      valign: 'middle'
    },

    headStyles: {
      fillColor: [82,82,82],
      textColor: [255, 255, 255],
      fontStyle: 'bold',
      halign: 'center',
      valign: 'middle',
      cellPadding: 3
    },

    alternateRowStyles: {
      fillColor: [242,242,242]
    },

    columnStyles: {
      0: {
        cellWidth: 9,
        halign: 'center'
      },
      1: {
        cellWidth: 25
      },
      2: {
        cellWidth: 35
      },
      3: {
        cellWidth: 113
      },
     
      4: {
        cellWidth: 19,
        halign: 'center'
      }
    },

    margin: {
      top: 15,
      right: margen,
      bottom: 18,
      left: margen
    },

    // Pie de página en cada página
    didDrawPage: () => {
      pdf.setDrawColor(210, 214, 220);
      pdf.setLineWidth(0.3);

      pdf.line(
        margen,
        altoPagina - 14,
        anchoPagina - margen,
        altoPagina - 14
      );

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor(100, 100, 100);

      pdf.text(
        'ADMIN SEAF | Listado de pasajeros activos',
        margen,
        altoPagina - 8
      );

      pdf.text(
        `Página ${pdf.getNumberOfPages()}`,
        anchoPagina - margen,
        altoPagina - 8,
        { align: 'right' }
      );
    }
  });

  // ==========================================
  // 4. DESCARGAR PDF
  // ==========================================

  const nombreArchivo =
    `Pasajeros_Extracto_${dato(extracto?.idfuec)}.pdf`;

  //pdf.save(nombreArchivo);

  console.log('PDF generado correctamente:', nombreArchivo);
}
}